import { useMemo } from 'react';

import useDashboardWidgets from '@/features/dashboard/hooks/useDashboardWidgets';

import { APP_CATALOG, type LauncherApp } from './catalog';
import { mergeAppLauncherConfig, type AppLauncherConfig } from './config';

/** Returns the ordered list of enabled apps to render in the launcher. */
export default function useAppLauncherConfig(): LauncherApp[] {
  const { data: resolved } = useDashboardWidgets();
  return useMemo(() => {
    const entry = resolved?.find((r) => r.id === 'app-launcher');
    const stored = (entry?.doc?.config as Partial<AppLauncherConfig> | undefined) ?? null;
    const { enabled } = mergeAppLauncherConfig(stored);
    return APP_CATALOG.filter((app) => enabled[app.id] !== false);
  }, [resolved]);
}
